import { Pipe, PipeTransform } from '@angular/core';
import firebase from 'firebase/compat';
import { Moment } from 'moment';
import { DatePipe } from '@angular/common';
import Timestamp = firebase.firestore.Timestamp;

@Pipe({ name: 'momentTimestampDate' })
export class MomentTimestampDatePipe implements PipeTransform {
  constructor(private datePipe$: DatePipe) {
  }

  transform(value: Timestamp | Moment | Date, ...args: string[]): unknown {
    if (!value) {
      return;
    }
    if (value instanceof Date) {
      return this.datePipe$.transform(value, args[0]);
    } else {
      return this.datePipe$.transform(value.toDate(), args[0]);
    }
  }

}
